import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import huHU from 'date-fns/locale/hu';
import DatePickerCustomInput from './DatePickerCustomInput';
import './datepicker.css';
import DateUtils from '@utils/DateUtils';

registerLocale('hu-HU', huHU);


interface PropType {
    name: string;
    value: string | null | undefined;
    placeholder?: string;
    hint?: string;
    isClearable?: boolean;
    required?: boolean;
    onChange: (value: any, name: string) => void;
}

const InputDate = (props: PropType) => {
    return (
        <>
            <DatePicker
                customInput={<DatePickerCustomInput />}
                selected={props.value ? new Date(props.value) : null}
                onChange={(date: Date) => { props.onChange(date ? DateUtils.formatDate(date) : '', props.name); }}
                onSelect={(date: Date) => { props.onChange(date ? DateUtils.formatDate(date) : '', props.name); }}
                dateFormat={'yyyy-MM-dd'}
                locale={'hu-HU'}
                isClearable={props.isClearable !== undefined ? props.isClearable : (props.required ? false : true)}
                placeholderText={props.placeholder}
            />
            {props.hint && <span className="form-text m-b-none">{props.hint}</span>}
        </>
    );
};

export default InputDate;



// WEBPACK FOOTER //
// ./src/components/Form/InputDate.tsx